import * as React from 'react';
import { Jumbotron, Container } from 'reactstrap';
import { Auth, postJson } from '../../Services';
import Endpoints from '../../Utils/Endpoints';
import { IResources } from '../../Types/IResources';

enum PasswordResetStatus {
    Error,
    Success,
    Canceled
}

interface IPasswordResetLandingProps {
    resources: IResources;
}

interface IPasswordResetLandingState {
    status: PasswordResetStatus;

}

export class PasswordResetLanding extends React.Component<IPasswordResetLandingProps, IPasswordResetLandingState>{
    constructor(props: any) {
        super(props);

        this.state = {
            status: Auth.hasError ? Auth.getError().startsWith("AADB2C90091") ? PasswordResetStatus.Canceled: PasswordResetStatus.Error : PasswordResetStatus.Success
        }
    }

    componentDidMount() {
        if (this.state.status == PasswordResetStatus.Success) {
            postJson(Endpoints.SetUserPasswordResetFalse + "?id=" + Auth.getUser().id, "");
        }
    }

    title =():string => {
        switch (this.state.status) {
            case PasswordResetStatus.Error:
                return `${this.props.resources.Error}!`;
            case PasswordResetStatus.Canceled:
                return `${this.props.resources.Canceled}!`;
            case PasswordResetStatus.Success:
                return `${this.props.resources.Success}!`;
        }
    }

    content = (): JSX.Element => {
        switch (this.state.status) {
            case PasswordResetStatus.Error:
                return <span>{this.props.resources.YourPasswordCouldNotBeReset_1}<a href='#' onClick={Auth.reAuthenticateAfterPasswordReset}>{this.props.resources.ClickHere_LowerCase}</a>{this.props.resources.YourPasswordCouldNotBeReset_2}<a href={"mailto:verilite.support@reply.com?Subject=Password%20reset%20error&Body=The%20following%20error%20was%20recieved%20while%20trying%20to%20complete%20a%20password%20reset:%0D%0A" + encodeURI(Auth.getError())} target="_top">{this.props.resources.VeriLiteSupportEmail}</a></span>;
            case PasswordResetStatus.Canceled:
                return <span>{this.props.resources.Please} <a href='#' onClick={Auth.reAuthenticateAfterPasswordReset}>{this.props.resources.ClickHere_LowerCase}</a> {this.props.resources.ToReturn}.</span>;
            case PasswordResetStatus.Success:
                return <span>{this.props.resources.PasswordHasBeenReset}<a href='#' onClick={Auth.reAuthenticateAfterPasswordReset}>{this.props.resources.SignIn_LowerCase}</a>{this.props.resources.ToContinue}</span>;
        }
    }

    render() {
        return (
            <div>
                <Jumbotron fluid>
                    <Container fluid>
                        <h1 className="display-3">{this.title()}</h1>
                        <p className="lead">{this.content()}</p>
                    </Container>
                </Jumbotron>
            </div>
        );
    }
}